import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { AxiosError } from "axios";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SectionHeader from "../../../../util/component/SectionHeader";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import useTenant from "../../hooks/useTenant";
import { IVehicleAvailabilityState } from "../../page/VehicleAvailabilityPage";
import VehicleAvailabilityService from "./service/VehicleAvailabilityService";

interface FormInputs {
  plate: string;
}

const VehicleAvailabilitySearch = () => {
  const navigate = useNavigate();
  const {TenantAutocomplete } = useTenant();
  const {tenant} = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();

  const form = useForm<FormInputs>();

  const onSubmit = (data: FormInputs) => {
    VehicleAvailabilityService.get.vehicleByPlate(tenant,data.plate?.trim()).then(
      response => {
        navigate(`/operation/vehicles/availabilityManagement/status`, {
          state: {
            tenant:tenant,
            id: response?.id,
            plate: response?.plate,
            modelType: `${response?.model.brand.descr} ${response?.model.descr}`,
            referenceLocationDesc: response?.referenceLocationDescription,
            referenceLocationType: response?.referenceLocationType,
          } as IVehicleAvailabilityState
        })
      },
      (reject: AxiosError) => {
        if (reject?.response?.status === 404) {
          snackbar.show("warning", t("vehicleAvailability.search.notFound").replace("#plateNotFound", data.plate));
        } else {
          snackbar.show("error", t("vehicleAvailability.search.generalError"));
        }
      }
    )
  }

  return (
    <Mui.Box>  
      <SectionHeader
          title={t("vehicleAvailability.search.titleBlue") + " " + t("vehicleAvailability.search.titleViolet")}
      />

      <form id="vehicle-availabilty-search" onSubmit={form.handleSubmit(onSubmit)}>
        <Mui.Box height="calc(100vh - 48px - 88px - 32px)" padding={{ md: 2, xs:0 }}>
          <Mui.Card style={{ height: "100%" }}>
            <Mui.CardContent style={{ height: "100%" }}>
              <Mui.Stack height="calc(100% - 32px)" overflow="auto">
                <Mui.Typography variant="h4" textAlign="center" mb={2}>
                  {t("vehicleAvailability.search.content.title")}
                </Mui.Typography>
                
                <Mui.Typography variant="body" whiteSpace="pre-line" textAlign="center" mb="80px">
                  {t("vehicleAvailability.search.content.description")}
                </Mui.Typography>
                
                <Mui.Grid container  columns={12} p="0px 16px" mb="25px" spacing={2}>
                  
                  {TenantAutocomplete}
                 
                  <Mui.Grid 
                    item 
                    xl={TenantAutocomplete ? 9 : 12} 
                    lg={TenantAutocomplete ? 9 : 12} 
                    md={TenantAutocomplete ? 6 : 12} 
                    xs={12}
                  >
                  <Mui.TextField 
                    label={t("vehicleAvailability.search.content.inputs.plate.label")}
                    variant="standard" 
                    placeholder={t("vehicleAvailability.search.content.inputs.plate.placeholder")}
                    {...form.register("plate")}
                    value={form.watch("plate") || ""}
                    fullWidth
                  />
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Stack direction="row" alignItems="center" justifyContent="center" mb="25px">
                  <Mui.Typography variant="body">
                    {t("vehicleAvailability.search.content.scanText")}
                  </Mui.Typography>
                  <MuiIcons.InfoOutlined style={{ marginLeft: "5px" }} />
                </Mui.Stack>

                <Mui.Button variant="contained" color="accent" disabled={true} style={{ margin: "0px 16px"}}>
                  {t("vehicleAvailability.search.content.buttonScan")} <MuiIcons.QrCode />
                </Mui.Button>

                <Mui.Button variant="contained" color="accent" type="submit" style={{ margin: "auto 16px 0px 16px" }}>
                  {t("vehicleAvailability.search.content.buttonSearch")}
                </Mui.Button>
              </Mui.Stack>
            </Mui.CardContent>
          </Mui.Card>
        </Mui.Box>
      </form>
    </Mui.Box>
  )
}

export default VehicleAvailabilitySearch;